<script setup>
import { defineEmits, defineProps } from 'vue'

defineProps({
    currentPage: {
        type: Number,
        default: 1
    },
    pageSize: {
        type: Number,
        default: 10
    },
    pageSizes: {
        type: Array,
        default: () => [10, 15, 20, 30, 50, 100]
    },
    layout: {
        type: String,
        default: 'total,sizes,prev, pager, next,jumper'
    }
})
const emits = defineEmits(['current-change', 'size-change'])

/**
 * page-size 每页显示条目个数改变时触发
 * @param pageSize {Number} 每页显示条目个数
 */
function sizeChange(pageSize) {
    emits('size-change', pageSize)
}

/**
 * current-page 当前页数改变时触发
 * @param currentPage {Number} 当前页数
 */
function currentChange(currentPage) {
    emits('current-change', currentPage)
}
</script>

<template>
    <el-pagination
        class="pagination"
        background
        :layout="layout"
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="pageSizes"
        v-bind="$attrs"
        @size-change="sizeChange"
        @current-change="currentChange"
    />
</template>

<style scoped lang="scss">
.pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;
}
</style>
